import Vue from 'vue'
import App from './App.vue'
import { createRouter } from './router'
import { createStore } from './store'
import { FormModel } from 'ant-design-vue';

Vue.config.productionTip = false

Vue.use(FormModel);

new Vue({
    router: createRouter(),
    store: createStore(),
    render: h => h(App),
}).$mount('#app')
